import { OrderTrackingBillingSettings } from "../../team";

/**
 * Messy parameter type, but it allows for either the zod type or the mongoose model
 */
export function isInvoiceBillingActive<
  T extends
    | (Pick<OrderTrackingBillingSettings, "enabled"> & {
        invoiceBilling?:
          | Pick<
              NonNullable<OrderTrackingBillingSettings["invoiceBilling"]>,
              "enabled" | "startDate"
            >
          | null
          | undefined;
      })
    | null
    | undefined,
>(
  settings: T,
): settings is NonNullable<T> & {
  invoiceBilling: NonNullable<NonNullable<T>["invoiceBilling"]>;
} {
  return !!(
    settings?.enabled &&
    settings.invoiceBilling?.enabled &&
    settings.invoiceBilling.startDate &&
    // Probably don't need to call new Date here, but we've been
    // burned by dates-that-are-actually-strings before.
    new Date(settings.invoiceBilling.startDate) < new Date()
  );
}
